import { update } from "./API";

export const UpdateProvider = async (provider_id: number, payload: any) => {
  try {
    return await update(
      `${process.env.REACT_APP_API_URL}/providers/${provider_id}`,
      payload
    );
  } catch (err: any) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
